export class OmegaVehicleDetails {
    public vehicleId: number;
    public legendType1: any;
    public legendType2: any;
    public legendType3: any;
}
